import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import CountUp, { startAnimation } from 'react-countup';
import { Watch } from 'scrollmonitor-react';
import base from '../../base.styl';
import styles from './ThreeColumns.styl';

/* eslint import/no-webpack-loader-syntax: off */
class ThreeColumns extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasAnimated: false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isInViewport && this.state.hasAnimated === false) {
      startAnimation(this.yearCountup);
      startAnimation(this.percentCountup);
      startAnimation(this.speciesCountup);
      this.setState({
        hasAnimated: true
      })
    }
  }

  doAnimation() {}

  render() {
    return (
      <Grid fluid className={base.container}>
        <Row className={styles.statsRow}>
          <Col xs={12} sm={4}>
            <h1>
              <CountUp
                className={styles.header}
                start={0}
                end={1973}
                duration={3}
                ref={countUp => {
                  this.yearCountup = countUp;
                }}
              />
            </h1>
            {/* <h1 className={styles.header}>1973</h1> */}
            <h3 className={styles.subtitle}>year the esa was enacted</h3>
            <p className={styles.infoParagraph}>
              The Endangered Species Act was passed in the early '70s alongside
              other cornerstone environmental laws like the Clean Air Act and
              the Clean Water Act. Together these laws safeguard the air we
              breathe, the water we drink and our planet's wildlife.
            </p>
          </Col>
          <Col xs={12} sm={4}>
            <h1>
              <CountUp
                className={styles.header}
                start={0}
                end={99}
                duration={3}
                suffix="%"
                ref={countUp => {
                  this.percentCountup = countUp;
                }}
              />
            </h1>
            {/* <h1 className={styles.header}>99%</h1> */}
            <h3 className={styles.subtitle}>species saved from extinction</h3>
            <p className={styles.infoParagraph}>
              Nearly every species listed under the ESA is still around - and
              many of them, including the American alligator and bald eagle, have
              made full recoveries.
            </p>
          </Col>
          <Col xs={12} sm={4}>
            <h1>
              <CountUp
                className={styles.header}
                start={0}
                end={2300}
                duration={3}
                separator=","
                useGrouping={true}
                ref={countUp => {
                  this.speciesCountup = countUp;
                }}
              />
            </h1>
            {/* <h1 className={styles.header}>2,300</h1> */}
            <h3 className={styles.subtitle}>
              plant and animal species currently listed
            </h3>
            <p className={styles.infoParagraph}>
              Of those species, more than 1,400 are animals, including 382 
              mammals like the Sonoran pronghorn antelope and Asian elephant
            </p>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Watch(ThreeColumns);



// WEBPACK FOOTER //
// ./src/components/static/ThreeColumns.js